import styled from 'styled-components';

import { StyledComponent } from '../../../interfaces';
import { FormField } from '../../formField/formField.component';

export const StyledFormField: StyledComponent<typeof FormField> = styled(FormField)`
  width: 100%;

  & + & {
    margin-left: 12px;
  }
`;

export const FieldsRow: StyledComponent<'div'> = styled.div`
  width: 100%;
  display: flex;

  & + & {
    margin-top: 24px;
  }
`;

export const HiddenInput: StyledComponent<'input'> = styled.input``;

export const FormikForm: StyledComponent<'form'> = styled.form`
  width: 100%;
`;
